/* eslint-disable */
module.exports = {
    console(el, className) {
        console.log('Hello form Github Package Registry :D' + el + className)
    },
    hasClass(el, className) {
        if (el.classList) return el.classList.contains(className)
        return !!el.className.match(new RegExp(`(\\s|^)${className}(\\s|$)`))
    },

    addClass(el, className) {
        const classList = className.split(' ')
        if (el.classList) el.classList.add(classList[0])
        else if (!this.hasClass(el, classList[0])) this.el.className += ` ${classList[0]}`
        if (classList.length > 1) this.addClass(el, classList.slice(1).join(' '))
    },

    removeClass(el, className) {
        const classList = className.split(' ')
        if (el.classList) el.classList.remove(classList[0])
        else if (this.hasClass(el, classList[0])) {
            const reg = new RegExp(`(\\s|^)${classList[0]}(\\s|$)`)
            this.el.className = el.className.replace(reg, ' ')
        }
        if (classList.length > 1) this.removeClass(el, classList.slice(1).join(' '))
    },

    toggleClass(el, className, bool) {
        if (bool) this.addClass(el, className)
        else this.removeClass(el, className)
    },

    setAttributes(el, attrs) {
        for (const key in attrs) {
            el.setAttribute(key, attrs[key])
        }
    },

    /*
	  DOM manipulation
	*/
    getChildrenByClassName(el, className) {
        const { children } = el
        const childrenByClass = []
        for (let i = 0; i < el.children.length; i++) {
            if (this.hasClass(el.children[i], className)) childrenByClass.push(el.children[i])
        }
        return childrenByClass
    },

    is(elem, selector) {
        if (selector.nodeType) {
            return elem === selector
        }

        const qa = (typeof (selector) === 'string' ? document.querySelectorAll(selector) : selector)
        let { length } = qa
        const returnArr = []

        while (length--) {
            if (qa[length] === elem) {
                return true
            }
        }

        return false
    },

    /*
		Animate height of an element
	*/
    setHeight(start, to, element, duration, cb) {
        const change = to - start
        let currentTime = null

        var animateHeight = function (timestamp) {
            if (!currentTime) currentTime = timestamp
            const progress = timestamp - currentTime
            const val = parseInt((progress / duration) * change + start)
            element.style.height = `${val}px`
            if (progress < duration) {
                window.requestAnimationFrame(animateHeight)
            } else {
                cb()
            }
        }

        // set the height of the element before starting animation -> fix bug on Safari
        element.style.height = `${start}px`
        window.requestAnimationFrame(animateHeight)
    },

    /*
		Smooth Scroll
	*/

    scrollTo(final, duration, cb) {
        const start = window.scrollY || document.documentElement.scrollTop
        let currentTime = null

        var animateScroll = function (timestamp) {
            if (!currentTime) currentTime = timestamp
            let progress = timestamp - currentTime
            if (progress > duration) progress = duration
            const val = Math.easeInOutQuad(progress, start, final - start, duration)
            window.scrollTo(0, val)
            if (progress < duration) {
                window.requestAnimationFrame(animateScroll)
            } else {
                cb && cb()
            }
        }

        window.requestAnimationFrame(animateScroll)
    },

    /*
	  Focus utility classes
	*/

    // Move focus to an element
    moveFocus(element) {
        if (!element) element = document.getElementsByTagName('body')[0]
        element.focus()
        if (document.activeElement !== element) {
            element.setAttribute('tabindex', '-1')
            element.focus()
        }
    },

    /*
	  Misc
	*/

    getIndexInArray(array, el) {
        return Array.prototype.indexOf.call(array, el)
    },
    // cssSupports(property, value) {
    //     if ('CSS' in window) {
    //         return CSS.supports(property, value)
    //     }
    //     const jsProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase())
    //     return jsProperty in document.body.style
    // },

    // merge a set of user options into plugin defaults
    // https://gomakethings.com/vanilla-javascript-version-of-jquery-extend/
    extend() {
    // Variables
        const extended = {}
        let deep = false
        let i = 0
        const { length } = arguments

        // Check if a deep merge
        if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
            deep = arguments[0]
            i++
        }

        // Merge the object into the extended object
        const merge = function (obj) {
            for (const prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                // If deep merge and property is an object, merge properties
                    if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                        extended[prop] = extend(true, extended[prop], obj[prop])
                    } else {
                        extended[prop] = obj[prop]
                    }
                }
            }
        }

        // Loop through each object and conduct a merge
        for (; i < length; i++) {
            const obj = arguments[i]
            merge(obj)
        }

        return extended
    },

    // Check if Reduced Motion is enabled
    osHasReducedMotion() {
        if (!window.matchMedia) return false
        const matchMediaObj = window.matchMedia('(prefers-reduced-motion: reduce)')
        if (matchMediaObj) return matchMediaObj.matches
        return false // return false if not supported
    }

    /*
		Polyfills
	*/
    // Closest() method
    // if (!Element.prototype.matches) {
    //     Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector
    // }

    // if (!Element.prototype.closest) {
    //     Element.prototype.closest = function (s) {
    //         let el = this
    //         if (!document.documentElement.contains(el)) return null
    //         do {
    //             if (el.matches(s)) return el
    //             el = el.parentElement || el.parentNode
    //         } while (el !== null && el.nodeType === 1)
    //         return null
    //     }
    // }

    // // Custom Event() constructor
    // if (typeof window.CustomEvent !== 'function') {
    //     function CustomEvent(event, params) {
    //         params = params || {
    //             bubbles: false,
    //             cancelable: false,
    //             detail: undefined
    //         }
    //         const evt = document.createEvent('CustomEvent')
    //         evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    //         return evt
    //     }

    //     CustomEvent.prototype = window.Event.prototype

    //     window.CustomEvent = CustomEvent
    // }

    // /*
    // 		Animation curves
    // 	*/
    // Math.easeInOutQuad = function (t, b, c, d) {
    //     t /= d / 2
    //     if (t < 1) return c / 2 * t * t + b
    //     t--
    //     return -c / 2 * (t * (t - 2) - 1) + b
    // }

}



// WEBPACK FOOTER //
// ./js/util/util.js